import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/Account/Fetch'
import DeactivateAccount from '../../store/action/Account/Deactivate'
import ActivateAccount from '../../store/action/Account/Activate'
import ActionDelete from '../../store/action/Account/Delete'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAllPrevilages from '../../store/action/Previlage/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import {ClientId, DivisionId, PrevilageId} from "../../helper/HelperAuth";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import ResetPasswordAction from '../../store/action/UserLogin/ResetPassword'
import { Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "User",
            isadmin:false,
            showModal:false,
            user:"",
            passworduser:"",
            retypepassworduser:"",
            form: fromJS({
                'show' : false,
                'actionType': '',
                'item': fromJS({}),
                'new-password':'',
                'new-password-re' : '',
                'username':'',
            }),
            formSearch: fromJS({
                "search": ""
            }),
            searchForm : fromJS({
                "client-id"     : '',
                "division-id"   : '',
                "sender-id"     : '',
                "username"     : '',
                "group-id"      : ''
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-2", field: "username", caption: "username", allowSearch: true },
                { className : "col-sm-2", field: "full-name", caption: "fullname", allowSearch: true },
                { className : "col-sm-1", field: "status", caption: "status", allowSearch: true },
                { className : "col-sm-1", field: "privilege-name", caption: "privilege", allowSearch: true },
                { className : "col-sm-2", field: "client-name", caption: "client", allowSearch: true },
                { className : "col-sm-2", field: "division-name", caption: "division", allowSearch: true },    
                { className : "col-sm-2", cfield: "action", caption: "Actions", allowView: true, allowEdit: false, 
                custom: fromJS([
                    { "id": "Reset", "icon": "autorenew", "label": "Reset", "className": "text-info" },
                    { "id": "Activate", "icon": "done", "label": "Activate", "className": "text-warning" },
                    { "id": "Deactivate", "icon": "cancel", "label": "Deactivate", "className": "text-danger" }
                ])}    
            ],
            columnsview:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-2", field: "username", caption: "username", allowSearch: true },
                { className : "col-sm-2", field: "full-name", caption: "fullname", allowSearch: true },
                { className : "col-sm-1", field: "status", caption: "status", allowSearch: true },
                { className : "col-sm-1", field: "privilege-name", caption: "privilege", allowSearch: true },
                { className : "col-sm-2", field: "client-name", caption: "client", allowSearch: true },
                { className : "col-sm-2", field: "division-name", caption: "division", allowSearch: true },    
                { className : "col-sm-2", cfield: "action", caption: "Actions", allowView: true, allowEdit: false}
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
        this.handleChangeReset = this.handleChangeReset.bind(this);
        this.handlecanclemodal = this.handlecanclemodal.bind(this);
        this.handlesend = this.handlesend.bind(this)
    }

    
    async handleCustomAction(id, row) {
            if (id == "Activate"){
                var result2 = await this.props.activateAccount(row.get('username'))
                //debugger;
                if (result2.ok) {
                    toast.success("Activate Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                } else {
                    toast.error("Activate Failed", toast.POSITION.TOP_RIGHT);
                }
            } else if (id == "Deactivate"){
                var result2 = await this.props.deactivateAccount(row.get('username'))
                //debugger;
                if (result2.ok) {
                    toast.success("Deactivate Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                } else {
                    toast.error("Deactivate Failed", toast.POSITION.TOP_RIGHT);
                }
        }else if (id == "Reset"){
            this.setState({showModal:true,user:row.get('username')})
        }
    }

    handleOnBindCustomAction(actionId, row) {
        if (actionId === 'Activate') {
            if (row.get('status') !== 'inactive') {
                return false;
            }
        }else if (actionId === 'Deactivate') {
            if (row.get('status') !== 'active') {
                return false;
            }
        }

        return true;
    }

    async componentDidMount(){
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.actionGetAllClient()
        this.props.actionGetAllPrevilages()
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "username":value.get('username')
            }
        };

        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('username') +' Success!', toast.POSITION.BOTTOM_RIGHT)
            this.handleFindSearch(1);
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            // toast.error('Delete '+ value.get('username') +' Failed!', toast.POSITION.BOTTOM_RIGHT)
        }
    }
    handleChangeReset(field,value,label){
        if(field == "newpassword") this.setState({passworduser:value})
        else if (field == "retypepassword") this.setState({retypepassworduser:value})
    }
    async handlesend(){
        const {passworduser,retypepassworduser,user} = this.state
        if (passworduser == "" || passworduser == null || passworduser == undefined
                 || retypepassworduser == "" || retypepassworduser == null || retypepassworduser == undefined){
                    toast.error('password or retype password cannot be empty ', toast.POSITION.BOTTOM_RIGHT)
                    return false
        }else if(passworduser != retypepassworduser ){
            toast.error('password doesnt match', toast.POSITION.BOTTOM_RIGHT)
            //debugger
            return false
        }else{
            var formVal= this.state.form
            formVal = formVal.set("new-password",passworduser)
            formVal = formVal.set("new-password-re",retypepassworduser)
            formVal = formVal.set("username",user)
            //debugger
            var response = await this.props.resetPasswordAction(formVal);
            if(response.ok){
                toast.success('Password Reset!');
                this.setState({showModal:false,
                passworduser:"",retypepassworduser:"",user:""})
                this.handleFindSearch(1)
            }else{
                toast.error('Failed on reset password!');
            }
        }
    }
    handlecanclemodal(){
        this.setState({showModal:false,
        passworduser:"",retypepassworduser:"",user:""})
    }
    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        if(field === 'client-id'){
            formVal = formVal.set('sender-id','')
            formVal = formVal.set('division-id','')
            this.setState({ searchForm:formVal })
            this.setState({client_id: value})

            this.setState({client_id: value})
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id','')
            this.setState({ searchForm:formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ searchForm:formVal })

    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let sender_id = searchForm.get('sender-id');
        let group_id = searchForm.get('group-id');
        let res = null;
        let sender = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin


        if (PrevilageId != 1 && isAdmin == false && (client_id == "" || client_id == null || client_id == undefined)) client_id = ClientId;
        if (PrevilageId != 1 && isAdmin == false && (division_id == "" || division_id == null || division_id == undefined)) division_id = DivisionId;

        this.props.actionGetAllSender(client_id, division_id)
        setTimeout(() => {
            res = this.props.senderall;
            if (res.size > 0) sender.shift();
            {res.map((data, i) =>
                sender.push(data.get('sender-id'))
            )}

            if (sender_id != "" ) sender = [sender_id]

            if ((PrevilageId == 1|| isAdmin == true) && client_id == "") client_id = 0;
            if ((PrevilageId == 1|| isAdmin == true) && division_id == "") division_id = 0;
            if (group_id == "") group_id = 0;

            if (sender.length == 1 && sender[0] == null) {
                setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) sender.shift();
                    {res.map((dataSender, i) =>
                        sender.push(dataSender.get('sender-id'))
                    )}

                    bodyFInd = {
                        "client-id":client_id,
                        "division-id" : division_id,
                        "sender-id" : sender,
                        "username": searchForm.get('username'),
                        "group-id" : group_id
                    }

                    this.props.actionGet(page,this.state.sortForm, bodyFInd);
                }, 1500);
            } else {

                bodyFInd = {
                    "client-id":client_id,
                    "division-id" : division_id,
                    "sender-id" : sender,
                    "username": searchForm.get('username'),
                    "group-id" : group_id
                }

                this.props.actionGet(page,this.state.sortForm, bodyFInd);
            }
        }, 1500);
    }

    showContent(){
        var form = this.state.form;
        var column = this.state.columnsview
        if(PrevilageId == 1 || this.state.isadmin == true){
            column = this.state.columns
        }
        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.data ? fromJS(this.props.data) : fromJS({});

            return (
                <CustomGrid
                    title="Privilege"
                    columns={ column } 
                    items={ items }  
                    search={ this.state.search }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                    handleOnBindCustomAction={this.handleOnBindCustomAction}
                    handleCustomAction={this.handleCustomAction}
                >
                </CustomGrid>
            )
        }   
    }
    renderModalBody(username) {
        return (
            <div className="body">
                <div className="form-group row">
                    <span className="col-sm-3">Username</span>
                    <div className="col-sm-9">
                        <TextInputField className="form-control"
                                        value={username}
                                        disabled={true}

                        />
                    </div>
                </div>

                <div className="form-group row">
                    <span className="col-sm-3">New Password*</span>
                    <div className="col-sm-9">
                        <TextInputField className="form-control"
                                        password
                                        field={"newpassword"}
                                        value={this.state.passworduser}
                                        onChange={(field, value, label) => this.handleChangeReset(field,value,label)}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <span className="col-sm-3">Retype new Password*</span>
                    <div className="col-sm-9">
                        <TextInputField className="form-control"
                                        password
                                        field={"retypepassword"}
                                        value={this.state.retypepassworduser}
                                        onChange={(field, value, label) => this.handleChangeReset(field,value,label)}
                        />
                    </div>
                </div>
            </div>
        )
    }
    renderModalAction() {
        var btnSend =
                <div className="input-group-btn">
                    <button className="btn btn-success" type="submit" onClick={this.handlesend} >
                        <span> Send <i className="material-icons">send</i> </span>
                    </button>
                </div>
        return (
            <div className="input-group">
                <div style={{ width: "100%" }}></div>
                {btnSend}
                <div className="input-group-btn">
                    <button className="btn btn-danger" type="submit" onClick={this.handlecanclemodal} >
                        <span> Cancel <i className="material-icons">cancel</i> </span>
                    </button>
                </div>
            </div>
        )
    }

    render(){
        const { form, searchForm, errors,showModal } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add User"  :  form.get('actionType')  ) : "User";
        const  classHide = title == 'User' ? 'card' : 'card hidden';
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                    <Modal isOpen={showModal} toggle={() => { }} fade={false} >
                    <ModalHeader>
                        {"Reset Password"}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody(this.state.user)}
                    </ModalBody>
                    <ModalFooter>
                        {this.renderModalAction()}
                    </ModalFooter>
                </Modal>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Division"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Sender"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='group-id'
                                    value={searchForm.get('group-id')}
                                    options={fromJS({
                                        'source': this.props.previlagesall,
                                        'value': 'privilege-id',
                                        'label': 'privilege-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Group"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('group-id')}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <TextInputField className="form-control"
                                    field='username'
                                    value={searchForm.get('username')}
                                    onChange={(field, value) => this.handleChange(field,value, '')}
                                    placeholder="Username"
                                    disabled={ false }
                                    hasError={errors.has('username')}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                        Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
          data: state.user.users,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
          previlagesall: state.user.previlagesall,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
      actionGetAllPrevilages : ActionGetAllPrevilages,
      actionFindByGroupId:ActionFindByGroupId,
      deactivateAccount: DeactivateAccount,
      activateAccount: ActivateAccount,
      resetPasswordAction: ResetPasswordAction,
  }, dispatch),
)(Page);